"use client"

import { useState, useEffect } from "react"
import Link from "next/link"
import { Cookie } from "lucide-react"
import { Button } from "@/components/ui/button"
import { readCookieConsent, writeCookieConsent } from "@/lib/cookie-consent"

export function CookieConsentBanner() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setVisible(readCookieConsent(window.localStorage) === null)
  }, [])

  if (!visible) return null

  const handleAccept = () => {
    writeCookieConsent("accepted", window.localStorage)
    setVisible(false)
  }

  const handleReject = () => {
    writeCookieConsent("rejected", window.localStorage)
    setVisible(false)
  }

  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] border-t bg-white p-4 shadow-lg md:p-6">
      <div className="container flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <p className="flex items-start gap-2 text-sm text-gray-700 md:max-w-2xl">
          <Cookie className="mt-0.5 h-5 w-5 shrink-0 text-blue-600" />
          <span>
            Utilizamos cookies para melhorar sua experiência, manter sua sessão e analisar o uso da
            plataforma. Veja nossa{" "}
            <Link href="/privacy" className="font-medium text-blue-600 underline hover:text-blue-700">
              Política de Privacidade
            </Link>{" "}
            e nossa{" "}
            <Link href="/cookies" className="font-medium text-blue-600 underline hover:text-blue-700">
              Política de Cookies
            </Link>{" "}
            para saber mais.
          </span>
        </p>
        <div className="flex shrink-0 items-center gap-2">
          <Button
            variant="outline"
            onClick={handleReject}
            className="border-gray-300 text-gray-700 hover:bg-gray-100"
          >
            Recusar opcionais
          </Button>
          <Button onClick={handleAccept} className="bg-blue-600 hover:bg-blue-700">
            Aceitar todos
          </Button>
        </div>
      </div>
    </div>
  )
}
